module.exports = __webpack_public_path__ + "img/cate6.16ee611c.png";